//@flow
/**
 * Interface for Impact Radius tracking
*/
// eslint-disable-next-line import/no-nodejs-modules
import crypto from 'crypto';
import TrackJs from './trackjs-interface';

type Item = {
  subTotal:number,
  category:string,
  sku:string,
  quantity:number,
};

type ConversationData = {
  orderId:string,
  clickId:string,
  customerId:string,
  customerStatus:string,
  orderPromoCode:string,
  orderDiscount:number,
  currencyCode:string,
  items:Item[],
};

const getIre = () => {
  return window && window.ire;
};

const hashEmail = (email:string):string => {
  const hashed = crypto
    .createHash('sha1')
    .update(email)
    .digest('hex');
  return hashed;
};

const identify = (customerId:string, email:string) => {
  const ire = getIre();
  if (!ire) {
    TrackJs.track('identify: IRE not found');
    return;
  }
  // Per IRE requirements, email must be sha1-hex hashed
  const customerEmail = email ? hashEmail(email) : '';

  ire('identify', {customerId, customerEmail});
};

const trackConversation = (data:ConversationData) => {
  const ire = getIre();
  if (!ire) {
    TrackJs.track('trackConversation: IRE not found');
    return;
  }

  ire('trackConversion', 22748, data);
};

const addShoppersScript = (orderId:string, orderValue:number) => {
  if (global.inServer) return;
  // Bind AddShoppersConversion to window so it
  // is accessible in script that is subsequently
  // loaded
  window.AddShoppersConversion = {
    order_id: orderId,
    value: orderValue,
  };
  // Check if widget code already loaded
  if (window.AddShoppersWidget) {
    window.AddShoppersWidget.track_conv();
  }
  else {
    const js = document.createElement('script');
    js.type = 'text/javascript';
    js.id = 'AddShoppers';
    js.src = ('https:' == document.location.protocol ? 'https://shop.pe/widget/' : 'http://cdn.shop.pe/widget/') + 'widget_async.js#5f80b3a0bbddbd7bc8223456';
    js.addEventListener('load', () => {
      // The `AddShoppersWidget` object is not
      // immediately available on window after script
      // load, so use brief timeout
      setTimeout(() => {
        window.AddShoppersWidget && window.AddShoppersWidget.track_conv();
      }, 200);
    });
    document.getElementsByTagName("head")[0].appendChild(js);
  }
};

export default {
  identify,
  trackConversation,
  addShoppersScript,
};
